import { ApolloClient, ObservableQuery } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { ApolloLink } from 'apollo-link';
import { withClientState } from 'apollo-link-state';
import { onError } from 'apollo-link-error';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { defaults, resolvers } from './client';
import { withFcLink } from './utils/FcLink';

// monkey patch to solve issue where once a query fails, no future queries work.
// explaination is here: https://github.com/apollographql/react-apollo/issues/1385#issuecomment-359534837
// note: re-introduced for MATCH-4103, as underlying issue in apollo-client has not been fully resolved.
const originalSetVariables = ObservableQuery.prototype.setVariables;
/* istanbul ignore next */
ObservableQuery.prototype.setVariables = function (variables, tryFetch, fetchResults) {
  if (this.lastError) {
    this.resetLastResults();
  }
  return originalSetVariables.call(this, variables, tryFetch, fetchResults);
};

export default function getApolloClient({ session, uri, localLink, fcService }) {
  const httpLink = createHttpLink({ uri });
  const withAuth = setContext((_, { headers }) => {
    // get the authentication token from local storage if it exists
    return {
      headers: {
        ...headers,
        authorization: session && session.isValid() ? `Bearer ${session.jwt}` : null,
      },
    };
  });
  const authFailed = onError(({ networkError }) => {
    /* istanbul ignore next */
    if (networkError && networkError.statusCode === 401) {
      if (session && session.clear) session.clear();
    }
  });
  const cache = new InMemoryCache();

  const initialState = {
    ...defaults,
    hasFcLink: !!fcService,
  };
  const stateLink = withClientState({ resolvers, cache, defaults: initialState });
  const fcLink = fcService ? withFcLink({ service: fcService }) : null;
  const client = new ApolloClient({
    link: ApolloLink.from([withAuth, authFailed, stateLink, fcLink, localLink || httpLink].filter(Boolean)),
    cache,
  });
  client.hasFcLink = !!fcLink;
  return client;
}
